module.exports = __webpack_public_path__ + "static/media/zoomQuartier_Belvedere.54efae2a.webp";